<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="../styles/9780061970009_template.css" rel="stylesheet" type="text/css"/>
<title>The Fires of Jubilee</title>
<h2 class="aboutAuthorHead"><b>CONTENTS</b></h2>
<nav epub:type="toc" id="toc">
<ol>
<li class="toc_1" epub:type="frontmatter" id="ded"><span href="#/text/9780061970009_Dedication#ded01" title="Link target outside of Sample"><i>Dedication</i></span></li>
<li class="toc_1" epub:type="frontmatter" id="ep"><span href="#/text/9780061970009_Epigraph#ep01" title="Link target outside of Sample"><i>Epigraph</i></span></li>
<li class="toc_1" epub:type="chapter" id="fm_01" style="margin-top:1em;"><a href="#/text/9780061970009_Frontmatter#fm01"><i>Foreword to the Perennial Library Edition</i></a></li>
<li class="toc_1" epub:type="chapter" id="pro_01" style="padding-top:1em;"><a href="#/text/9780061970009_Prologue#pro01"><b>PROLOGUE</b>: Southampton County, 1831</a></li>
<li class="toc_1" epub:type="chapter" id="pt_01" style="padding-top:1em;"><a href="#/text/9780061970009_Part_1#pt01"><i>Part One</i>: <b>THIS INFERNAL SPIRIT OF SLAVERY</b></a></li>
<li class="toc_1" epub:type="chapter" id="pt_02" style="padding-top:1em;"><span href="#/text/9780061970009_Part_2#pt02" title="Link target outside of Sample"><i>Part Two</i>: <b>GO SOUND THE JUBILEE</b></span></li>
<li class="toc_1" epub:type="chapter" id="pt_03" style="padding-top:1em;"><span href="#/text/9780061970009_Part_3#pt03" title="Link target outside of Sample"><i>Part Three</i>: <b>JUDGMENT DAY</b></span></li>
<li class="toc_1" epub:type="chapter" id="pt_04" style="padding-top:1em;"><span href="#/text/9780061970009_Part_4#pt04" title="Link target outside of Sample"><i>Part Four</i>: <b>LEGACY</b></span></li>
<li class="toc_1" epub:type="chapter" id="epil_01" style="padding-top:1em;"><span href="#/text/9780061970009_Epilogue#epil01" title="Link target outside of Sample"><b>EPILOGUE</b>: Southampton County, 1973</span></li>
<li class="toc_1" epub:type="chapter" id="bm_01" style="padding-top:1em;"><span href="#/text/9780061970009_Note#bm01" title="Link target outside of Sample"><i>Reference Notes</i></span></li>
<li class="toc_1" epub:type="chapter" id="ind_01" style="padding-top:1em;"><span href="#/text/9780061970009_Backmatter#ind01" title="Link target outside of Sample"><i>Searchable Terms</i></span></li>
<li class="toc_1" epub:type="chapter" id="map_01" style="padding-top:1em;"><span href="#/text/9780061970009_Map#map01" title="Link target outside of Sample"><b>MAPS</b></span></li>
<li class="toc_1" epub:type="chapter" id="map_1" style="padding-top:1em;"><span href="#/text/9780061970009_Map#map1" title="Link target outside of Sample"><i>Southeastern Virginia, 1831</i></span></li>
<li class="toc_1" epub:type="chapter" id="map_2" style="padding-top:1em;"><span href="#/text/9780061970009_Map#map2" title="Link target outside of Sample"><i>Nat Turner Country</i></span></li>
<li class="toc_1" epub:type="backmatter" id="rps" style="margin-top:0.5em"><span href="#/text/9780061970009_PS#ps" title="Link target outside of Sample">P.S. Insights, Interviews &amp; More . . .*</span></li>
<li class="toc_1" epub:type="backmatter" id="rata" style="text-indent:1em"><span href="#/text/9780061970009_PS_About_the_Author#ata" title="Link target outside of Sample">About the author</span></li>
<li class="toc_1" epub:type="backmatter" id="ratb" style="text-indent:1em"><span href="#/text/9780061970009_PS_About_Book#atb" title="Link target outside of Sample">About the book</span></li>
<li class="toc_1" epub:type="backmatter" id="rread" style="text-indent:1em; margin-bottom:1em;"><span href="#/text/9780061970009_PS_Read_On#read" title="Link target outside of Sample">Read on</span></li>
<li class="toc_1" epub:type="chapter" id="adc_01" style="margin-top:2em;"><span href="#/text/9780061970009_Also_by#adc01" title="Link target outside of Sample"><i>Books by Stephen B. Oates</i></span></li>
<li class="toc_1" epub:type="chapter" id="cop_01"><span href="#/text/9780061970009_Copyright#cop01" title="Link target outside of Sample"><i>Copyright</i></span></li>
<li class="toc_1" epub:type="chapter" id="atp_01"><span href="#/text/About_the_Publisher#atp01" title="Link target outside of Sample"><i>About the Publisher</i></span></li>
</ol>
</nav>
<div class="hide1">
<nav epub:type="landmarks" hidden="hidden">
<h1 class="toc">Guide</h1>
<ol style="text-indent:1em">
<li><span epub:type="cover" href="#/text/9780061970009_Cover" title="Link target outside of Sample">Cover</span></li>
<li><a epub:type="toc" href="#/text/nav">Contents</a></li>
<li><a epub:type="bodymatter" href="#/text/9780061970009_Part_1">Part 1</a></li>
</ol>
</nav>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?6ddf5a1a